import { useEffect, useState } from "react";
import "../../styles/UserDashboard/OnboardingTemplate.scss";
import { submitBusinessPlusTemplate } from "../../apis/General/users";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
// import { countries } from "../../data/countries";

export default function BusinessPlusOnboardingTemplates() {
  const auth = useSelector((state) => state.auth);
  const pathname = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  // Form state
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [industry, setIndustry] = useState("");
  const [facilityCategory, setFacilityCategory] = useState("");
  // const [country, setCountry] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [companyName, setCompanyName] = useState("");

  // Error modal state
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [errorButtonAction, setErrorButtonAction] = useState("ok");
  const [userId, setUserId] = useState("");

  // Set verifier from params
  // useEffect(() => {
  //   if (params?.verifier?.toLowerCase() === "echon") {
  //     setSubCcv(params.verifier.toLowerCase());
  //   }
  // }, [params]);

  // Wallet address validation
  const isValidWalletAddress = (address) => {
    return /^(0x)[0-9a-f]{40}$/i.test(address);
  };

  // Form validation
  const isFormValid = () => {
    return (
      firstName.trim() &&
      lastName.trim() &&
      email.trim() &&
      // country.trim() &&
      companyName.trim() &&
      industry.trim() &&
      facilityCategory &&
      walletAddress.trim() &&
      termsAccepted &&
      isValidWalletAddress(walletAddress)
    );
  };

  const handleShowError = (title, body, action = "ok") => {
    setErrorTitle(title);
    setErrorText(body);
    setErrorButtonAction(action);
    setErrorModalOpen(true);
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (!/^(0x)[0-9a-f]{40}$/i.test(walletAddress)) {
      alert("Invalid wallet address");
      setLoading(false);
      return false;
    }
    // Add this to debug the API call
    console.log("About to call API with:", {
      subscriptionPlan: pathname?.pathname?.split('/')[2],
      firstName,
      lastName,
      email,
      // country,
      companyName,
      industry,
      facilityCategory,
      walletAddress,
      token: auth?.token
    });
    try {
      const response = await submitBusinessPlusTemplate({
        subscriptionPlan: pathname?.pathname?.split('/')[2],
        firstName,
        lastName,
        email,
        // country,
        companyName,
        industry,
        facilityCategory,
        walletAddress,
        token: auth?.token
      });

      if (response?.data?.statusCode === 200) {
        localStorage.setItem("demosent", "true");
        navigate(`/plans/business-plus/pay/${response.data.message}`);
      } else {
        handleErrorResponse(response);
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("An error occurred during submission. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleErrorResponse = (response) => {
    const message = response?.data?.message;

    switch (message) {
      case "This email has been registered. Kindly login":
        handleShowError(
          "Email Already Registered",
          "This email has already been registered. If you've forgotten your password, click 'Forgot Password' on the login screen.",
          "login"
        );
        break;

      case "KYC submitted. Kindly verify your email.":
        handleShowError(
          "Email Verification Required",
          "This email already exists. Please click the button below to input the OTP sent to your email to activate your account.",
          "otp"
        );
        setUserId(response?.data?.userId);
        break;

      case "This email has been registered. Kindly complete the sign up process":
        handleShowError(
          "Complete Registration",
          "This email has already been registered. Please click the button below to complete the sign up process.",
          "register"
        );
        setUserId(response?.data?.userId);
        break;

      default:
        toast.error(message || "An error occurred. Please try again.");
    }
  };

  const handleErrorModalClose = (e) => {
    if (e.target.classList.contains("errorModal")) {
      setErrorModalOpen(false);
    }
  };

  const handleErrorButtonClick = () => {
    switch (errorButtonAction) {
      case "login":
        navigate("/login");
        break;
      case "register":
        navigate(`/signup/${userId}/3`);
        break;
      case "otp":
        navigate(`/signup/${userId}`);
        break;
      default:
        setErrorModalOpen(false);
    }
  };

  return (
    <div className="onboarding-template">
      <div className="onboarding-template__title">
        Almost there! Tell us about your facility for a perfect fit.
      </div>
      <div className="onboarding-template__subtitle">
        Fill this simple form to help us understand your facility.
      </div>

      <form onSubmit={handleSubmit}>
        <label className="onboarding-template__input-label" htmlFor="firstName">
          First name
        </label>
        <input
          className="onboarding-template__input"
          required
          id="firstName"
          type="text"
          placeholder="Enter your first name"
          name="firstName"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />

        <label className="onboarding-template__input-label" htmlFor="lastName">
          Last name
        </label>
        <input
          className="onboarding-template__input"
          required
          id="lastName"
          type="text"
          placeholder="Enter your last name"
          name="lastName"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />

        <label className="onboarding-template__input-label" htmlFor="email">
          Email
        </label>
        <input
          className="onboarding-template__input"
          required
          id="email"
          type="email"
          placeholder="Enter email address"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* <label className="onboarding-template__input-label" htmlFor="country">
          Country
        </label>
        <select
          className="onboarding-template__input onboarding-template__input-select"
          required
          id="country"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
        >
          <option value="">Select country</option>
          {countries?.map((country, index) => (
            <option key={index} value={country?.label}>
              {country?.label}
            </option>
          ))}
        </select> */}


        <label
          className="onboarding-template__input-label"
          htmlFor="lastName"
        >
          Company name
        </label>

        <input
          className="onboarding-template__input"
          required
          id="companyName"
          type="text"
          placeholder="Enter company name"
          name="companyName"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
        />


        <label className="onboarding-template__input-label" htmlFor="industry">
          Industry
        </label>
        <input
          className="onboarding-template__input"
          required
          id="industry"
          type="text"
          placeholder="Enter the industry your company falls under e.g food industry, oil and gas"
          name="industry"
          value={industry}
          onChange={(e) => setIndustry(e.target.value)}
        />

        <label className="onboarding-template__input-label" htmlFor="facilityCategory">
          Facility category
        </label>
        <select
          className="onboarding-template__input onboarding-template__input-select"
          required
          id="facilityCategory"
          value={facilityCategory}
          onChange={(e) => setFacilityCategory(e.target.value)}
        >
          <option value="">Select a facility category</option>
          <option value="green">Green</option>
        </select>

        <label className="onboarding-template__input-label" htmlFor="walletAddress">
          Wallet address
        </label>
        <div className="onboarding-template__info">
          You can create a wallet and get an address on the <a href="https://metamask.io/" target="_blank" >MetaMask</a> website
        </div>
        <input
          className="onboarding-template__input"
          required
          id="walletAddress"
          type="text"
          placeholder="Enter your Ethereum Wallet Address (e.g., 0x1234...abcd)"
          name="walletAddress"
          value={walletAddress}
          onChange={(e) => setWalletAddress(e.target.value)}
        />
        <div className="onboarding-template__input-text">
          Note: Do not disclose your private key.
        </div>

        <div className="onboarding-template__container">
          {/* Custom SVG Checkbox */}
          <div className="onboarding-template__checkbox-wrapper">
            {!termsAccepted && (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setTermsAccepted(true)}
                style={{ cursor: 'pointer' }}
              >
                <rect x="1.5" y="1.5" width="21" height="21" rx="5" stroke="url(#paint0_linear_2889_18043)" strokeWidth="1.5" />
                <defs>
                  <linearGradient id="paint0_linear_2889_18043" x1="1.5" y1="1.82" x2="26.76" y2="14.38" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#006633" />
                    <stop offset="1" stopColor="#02A4CC" />
                  </linearGradient>
                </defs>
              </svg>
            )}

            {termsAccepted && (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setTermsAccepted(false)}
                style={{ cursor: 'pointer' }}
              >
                <rect x="1.5" y="1.5" width="21" height="21" rx="5" stroke="url(#paint0_linear_2889_18037)" strokeWidth="1.5" />
                <path d="M7 12.5L10.5 16L17 9" stroke="url(#paint1_linear_2889_18037)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <defs>
                  <linearGradient id="paint0_linear_2889_18037" x1="1.5" y1="1.82" x2="26.76" y2="14.38" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#006633" />
                    <stop offset="1" stopColor="#02A4CC" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_2889_18037" x1="7" y1="9.26" x2="17.03" y2="15.74" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#006633" />
                    <stop offset="1" stopColor="#02A4CC" />
                  </linearGradient>
                </defs>
              </svg>
            )}
          </div>

          <label className="onboarding-template__label" style={{ cursor: 'pointer' }} onClick={() => setTermsAccepted(!termsAccepted)}>
            <span>I confirm that I have read and agree to the</span>
            <a href="/privacy-policy" className="onboarding-template__link">
              <span> Privacy Policy and Terms & Conditions </span>
            </a>
            <span>for CloseCarbon.</span>
          </label>
        </div>

        <button
          className="onboarding-template__button"
          type="submit"
          disabled={loading || !isFormValid()}
        >
          <div>{loading ? "Loading..." : "Done"}</div>
        </button>
      </form>

      {/* Error Modal */}
      {errorModalOpen && (
        <>
          <div className="errorModal" onClick={handleErrorModalClose}></div>
          <div className="error_modal">
            <div className="modal_title">{errorTitle}</div>
            <div className="modal_subtitle">{errorText}</div>
            <button
              className="error_modal_button"
              type="button"
              onClick={handleErrorButtonClick}
              disabled={loading}
            >
              {loading ? "Loading..." : "Okay"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}